import React from 'react'
import Styles from './styles'
import { useSelector } from 'react-redux'
import { FormText } from 'reactstrap'
import { Download } from 'react-feather'
import { FormattedMessage } from 'react-intl'
import { toast } from 'react-toastify'
import _ from 'lodash'
import useAxios from 'axios-hooks'
import { Show } from '~/components/commons'
import { StyledSwitch } from '../../../../LocationsList/styles'
import { useSearchParamsHandler } from '~/contexts/FilterContext'

function HeaderMenu() {
  const currentProjectId = useSelector(state => state.user?.selectedProject?.id)
  const allProjectIds = useSelector(state =>
    state.user?.profile?.projects?.map(item => item.id)
  )
  const { query, setQuery } = useSearchParamsHandler()

  const allLocations = query.allLocations

  const [{ loading: csvLoading }, downloadCSV] = useAxios(
    {
      url: `/locations/csv`,
      method: 'GET',
      params: {
        project: allLocations ? undefined : currentProjectId,
      },
    },
    {
      useCache: true,
      manual: true,
    }
  )

  function handleToggleAllLocations(bool) {
    setQuery('allLocations', bool)
  }

  const handleCSV = React.useCallback(() => {
    downloadCSV()
      .then(({ data }) => {
        const blob = new Blob([data], { type: 'data:text/csv;charset=utf-8,' })
        const blobURL = window.URL.createObjectURL(blob)
        // Create new tag for download file
        const anchor = document.createElement('a')
        anchor.download = 'my-locations.csv'
        anchor.href = blobURL
        anchor.dataset.downloadurl = [
          'text/csv',
          anchor.download,
          anchor.href,
        ].join(':')
        anchor.click()
        // Remove URL.createObjectURL. The browser should not save the reference to the file.
        setTimeout(() => {
          // For Firefox it is necessary to delay revoking the ObjectURL
          URL.revokeObjectURL(blobURL)
        }, 100)
      })
      .catch(e => {
        toast.error('Error on downloading your CSV file.')
        console.error(e)
      })
  }, [downloadCSV])

  return (
    <Styles.HeaderMenu
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '1rem',
      }}
    >
      <Styles.CSVButton disabled={csvLoading} onClick={handleCSV}>
        <Download color="#fff" size={15} />
        <FormattedMessage id="Download my locations" />
      </Styles.CSVButton>
      <Show condition={allProjectIds.length > 1}>
        <StyledSwitch
          id="alllocations-switch"
          checked={allLocations}
          style={{ zIndex: '0 !important' }}
          onChange={e => handleToggleAllLocations(e.target.checked)}
          type="switch"
          inline
        >
          <span>
            <FormText className="text-bold-500 d-inline-block">
              <FormattedMessage id="View all account locations" />
            </FormText>
          </span>
        </StyledSwitch>
      </Show>
    </Styles.HeaderMenu>
  )
}

export default HeaderMenu
